import { useEffect, useRef } from "react"

export const useClickAway = (callback: VoidFunction) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const element = event.target as HTMLElement
      if (ref.current && !ref.current.parentElement?.contains(element) && !ref.current.contains(element)) {
        callback()
      }
    }

    document.addEventListener("click", handleClickOutside)
    return () => {
      document.removeEventListener("click", handleClickOutside)
    }
  }, [callback])

  return ref
}
